!function (global) {
  'use strict';

  var previouscallActionsPostLoginUtility = global.ActionsPostLoginUtility;

  function ActionsPostLoginUtility(options) {

    function encodeUrl(url) {
      return encodeURIComponent(url);
    }
    
    function urlMaker(actionOptions) {

      var urlAuxParams = actionOptions.auxParams.map(function (item, index) {
          return (
          'auxParams' + '[' + index + '].Name=' + item.Name + 
          '&auxParams' + '[' + index + '].Value=' + item.Value
        )
      }).join('&');


      var urlParams = (!actionOptions.urlParams)?"":actionOptions.urlParams.map(function (item, index) {
        return (
          item.Name + '=' + item.Value
        );
      }).join('&');

      return (actionOptions.urlBase + '?' + 
        '__previous_url__=' + encodeUrl(window.location.href) +
        '&' + urlAuxParams + ((urlParams === "")?'&': '&' + urlParams)
      );
    }

    function shouldDoLogin(actionOptions) {
      var urlMade = urlMaker(actionOptions);

      location.href = urlMade;
    }

    return {
      shouldDoLogin: shouldDoLogin
    }
  }

  ActionsPostLoginUtility.noConflict = function noConflict() {
    global.ActionsPostLoginUtility = previouscallActionsPostLoginUtility;
    return ActionsPostLoginUtility;
  };

  global.ActionsPostLoginUtility = ActionsPostLoginUtility;

}(this);
